import React from "react";
import { BiMessageSquareAdd } from "react-icons/bi";
import { useNavigate } from "react-router-dom";

const CreateMessageFAB = ({ course }) => {
  const navigate = useNavigate();
  return (
    <div
      className="create-message-FAB-container"
      onClick={() => navigate(`/Messages/${course.course_code}/create-message`)}
    >
      <BiMessageSquareAdd />
    </div>
  );
};

export default CreateMessageFAB;
